// extracted by mini-css-extract-plugin
export default {"recent-completed-cme":"RecentCme_recent-completed-cme__7uHmf"};